
import React from 'react';
import '../../../../Styles/ICASTMediaImpression.css';

const pressReleases = [
  {
    id: 1,
    outlet: 'Associated Press of Pakistan (APP)',
    category: 'Media Coverage',
    date: 'December 15, 2024',
    title:
      'Pakistan to Lead Global Dialogue on Space Applications with ICAST 2025',
    link:
      'https://www.app.com.pk/national/pakistan-to-lead-global-dialogue-on-space-applications-with-icast-2025-3/',
  },
  {
    id: 2,
    outlet: 'Associated Press of Pakistan (APP)',
    category: 'Conference Coverage',
    date: 'November 20, 2025',
    title:
      'ICAST 2025 Concludes with Historic Achievements and a Vision for a Sustainable Space Future',
    link:
      'https://www.app.com.pk/national/icast-2025-concludes-with-historic-achievements-global-partnerehips-and-a-vision-for-a-sustainable-space-future/',
  },
  {
    id: 3,
    outlet: 'Associated Press of Pakistan (APP)',
    category: 'Inauguration Coverage',
    date: 'November 18, 2025',
    title:
      'SUPARCO and IST Inaugurate Region’s Largest Space Science and Technology Conference',
    link:
      'https://www.app.com.pk/national/suparco-and-ist-inaugurate-regions-largest-space-science-and-technology-conference/',
  },
  {
    id: 4,
    outlet: 'Associated Press of Pakistan (APP)',
    category: 'Media Coverage',
    date: 'November 17, 2025',
    title:
      'Pakistan Hosts ICAST 2025, Bringing Global Space Community to Islamabad',
    link:
      'https://www.app.com.pk/national/pakistan-hosts-icast-2025-bringing-global-space-community-to-islamabad/',
  },
];

const ICASTMediaImpression = () => {
  return (
    <section
      className="icast-media-section"
      aria-labelledby="icast-media-title"
    >
      <div className="icast-media-inner">

        <div className="icast-media-heading">
          <p className="section-eyebrow">
            ICAST 2025 IN THE SPOTLIGHT
          </p>

          <h2 id="icast-media-title">
            Media and Impression
          </h2>

          <div
            className="world-space-week-title-line"
            aria-hidden="true"
          />

          <p className="icast-media-description">
            Explore national media coverage and press releases
            highlighting ICAST 2025, its international
            participation, scientific discussions, and
            contributions to sustainable development.
          </p>
        </div>

        <div className="icast-media-grid">
          {pressReleases.map((item) => (
            <a
              key={item.id}
              className="icast-media-card"
              href={item.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Read ${item.title} on ${item.outlet}`}
            >
              <div className="icast-media-card-top">

                <span
                  className="icast-media-icon"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="25"
                    height="25"
                  >
                    <rect
                      x="3"
                      y="4"
                      width="18"
                      height="16"
                      rx="2"
                    />
                    <rect x="6" y="7" width="5" height="5" />
                    <path d="M14 8h4M14 11h4M6 15h12M6 18h12" />
                  </svg>
                </span>

                <span className="icast-media-date">
                  {item.date}
                </span>
              </div>

              <span className="icast-media-outlet">
                {item.outlet}
              </span>

              <span className="icast-media-category">
                {item.category}
              </span>

              <h3>{item.title}</h3>

              <span className="icast-media-card-link">
                Read Full Story
                <span aria-hidden="true">↗</span>
              </span>
            </a>
          ))}
        </div>

        <div className="icast-media-footer">
          <a
            className="outreach-film-trailer-link"
            href="https://icast.pk/press-release"
            target="_blank"
            rel="noopener noreferrer"
          >
            View All Press Releases
            <span aria-hidden="true">↗</span>
          </a>
        </div>

      </div>
    </section>
  );
};

export default ICASTMediaImpression;
